export default "__VITE_ASSET__DVxlO6aC__"